module.exports = __webpack_public_path__ + "img/sample-dossirimarugo.386d3177.svg";